(() => {
  function init(scope) {
    scope.querySelectorAll('.rmc-driver-timeline').forEach(timeline => {
      const calendar = JSON.parse(timeline.querySelector('[data-timeline-calendar]')?.textContent || '[]');
      const node = (tag, text, className) => {
        const element = document.createElement(tag);
        if (text !== undefined) element.textContent = text;
        if (className) element.className = className;
        return element;
      };
      timeline.querySelectorAll('[data-timeline-fallback]').forEach(container => {
        if (container.dataset.ready) return;
        const groups = JSON.parse(container.querySelector('[data-timeline-results]').textContent);
        const podiumRules = JSON.parse(container.querySelector('[data-podium-rules]')?.textContent || 'null');
        const races = new Map();
        groups.flat().filter(row => row.final_number >= 1 && row.final_number <= 6).forEach(row => {
          const key = row.event_id ? 'id:' + row.event_id : 'name:' + row.event;
          if (!races.has(key)) races.set(key, []);
          races.get(key).push(row);
        });
        const year = Number(container.dataset.timelineYear);
        const events = [...races.values()].map(rows => {
          const first = rows[0];
          const matches = calendar.filter(race => Number(race.year) === year && (first.event_id ? Number(race.id) === Number(first.event_id) : race.name === first.event));
          const dates = [...new Set(matches.map(race => race.date).filter(Boolean))];
          return { rows, date: dates.length === 1 ? dates[0] : null };
        }).sort((a, b) => (b.date || '').localeCompare(a.date || '') || a.rows[0].event.localeCompare(b.rows[0].event, 'sv'));
        const list = node('ol', undefined, 'rmc-timeline-events');
        for (const event of events) {
          const item = node('li');
          const time = event.date ? node('time', event.date.slice(0, 10)) : node('span', year + ' · datum saknas', 'notice');
          if (event.date) time.dateTime = event.date;
          item.append(time, node('h3', event.rows[0].event));
          const finals = node('ul', undefined, 'rmc-timeline-finals');
          event.rows.sort((a, b) => (a.category_id || 0) - (b.category_id || 0) || a.final_number - b.final_number);
          for (const row of event.rows) {
            const lastFinal = row.event_id ? podiumRules?.by_id?.[String(row.event_id)]?.[String(row.category_id)] : podiumRules?.by_name?.[row.event]?.[String(row.category_id)];
            const podium = Number(lastFinal) === row.final_number && ['P1', 'P2', 'P3'].includes(row.position);
            const result = node('li', undefined, podium ? 'is-podium' : '');
            result.append(node('span', row.class_name + ' · ' + row.final), node('strong', row.position));
            if (row.position === 'P1') result.append(node('span', 'Seger'));
            else if (podium) result.append(node('span', 'Pallplats'));
            finals.append(result);
          }
          item.append(finals);
          list.append(item);
        }
        if (events.length) {
          container.append(list);
          container.querySelector('[data-timeline-placeholder]').hidden = true;
        }
        container.dataset.ready = 'true';
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

